import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Navimumbaiinternationairport() {



const cardData = {
  keyword: " Navi Mumbai International Airport (NMIA) Cabs",

"headingDescription": "Omshree Cab offers reliable and comfortable cab services at Navi Mumbai International Airport (NMIA) for travelers who need hassle-free airport pickups, drop-offs, and transfers. Whether you are arriving for business, leisure, or connecting flights, our airport cabs provide timely, safe, and efficient transportation. We offer a fleet of air-conditioned sedans, SUVs, and luxury vehicles driven by experienced chauffeurs who are familiar with Navi Mumbai traffic and routes. Flexible booking options include one-way, round trips, and multi-day plans at transparent per-kilometer pricing with no hidden charges. With 24/7 customer support and punctual pickups from the airport terminal, Omshree Cab ensures a seamless travel experience for both local and outstation passengers.",
  "topPlaces": [
    {
      "title": "CBD Belapur",
      "description": "CBD Belapur is a major commercial hub near Navi Mumbai International Airport. Travelers can reach corporate offices, business centers, and commercial complexes quickly and comfortably with airport cabs, ensuring a stress-free journey after flights."
    },
    {
      "title": "Vashi",
      "description": "Vashi is a prominent business and residential area accessible from NMIA. Cab services provide convenient and comfortable transfers for airport passengers heading to hotels, offices, or residential complexes in Vashi."
    },
    {
      "title": "Nerul",
      "description": "Nerul, a key residential and commercial sector, is well-connected to NMIA. Airport cabs ensure timely transportation for travelers arriving or departing, providing a smooth journey to homes, hotels, and business destinations."
    },
    {
      "title": "Belapur Fort",
      "description": "Belapur Fort is a historic landmark near the airport. Visitors and tourists can conveniently reach this site using NMIA cab services, combining sightseeing with hassle-free transportation."
    },
    {
      "title": "Seawoods Grand Central Mall",
      "description": "Seawoods Grand Central Mall is a popular shopping and entertainment destination near Navi Mumbai International Airport. Cab services provide travelers with easy access to shopping, dining, and leisure activities right after arrival or before departure."
    },
    {
      "title": "Kharghar Central Park",
      "description": "Kharghar Central Park is a scenic recreational area accessible from the airport. Airport cab services allow passengers to relax or explore this urban park conveniently before continuing to their next destination."
    },
    {
      "title": "Palm Beach Road",
      "description": "Palm Beach Road connects several residential and commercial areas near NMIA. Cabs from the airport provide smooth and timely travel along this route, ideal for business travelers and tourists."
    },
    {
      "title": "Utsav Chowk",
      "description": "Utsav Chowk is a notable landmark near Kharghar and easily reachable from NMIA. Airport cabs provide comfortable and efficient travel for passengers visiting this area for leisure, meetings, or sightseeing."
    },
    {
      "title": "Nerul Balaji Temple",
      "description": "Nerul Balaji Temple is a spiritual destination accessible from NMIA. Cab services provide easy transportation for pilgrims and travelers arriving at the airport who wish to visit the temple conveniently."
    },
    {
      "title": "Sagar Vihar, Vashi",
      "description": "Sagar Vihar is a peaceful waterfront promenade in Vashi near the airport. Airport cabs allow travelers to enjoy the scenic views, evening walks, and a relaxing environment right after landing or before departure."
    }
  ],



services: [
{
name: "NMIA Airport Cabs",
description: "NMIA airport cabs provide reliable transportation services for passengers traveling to and from Navi Mumbai International Airport. Travelers can easily book comfortable vehicles for airport pickup and drop services across Navi Mumbai and surrounding cities. Our fleet includes sedans, SUVs, and spacious MPV vehicles suitable for airport travel. Professional drivers ensure punctual arrival and safe driving for stress-free airport transfers. Vehicles provide spacious seating, air-conditioned comfort, and sufficient luggage space. The service is ideal for business travelers, tourists, and families. Passengers enjoy smooth and dependable transportation to NMIA airport."
},
{
name: "Navi Mumbai International Airport Taxi",
description: "Navi Mumbai International Airport taxi service offers convenient airport transportation for travelers arriving or departing from NMIA. The taxi provides comfortable seating and smooth ride quality for airport journeys. Professional drivers ensure timely pickup and safe travel across Navi Mumbai locations. Vehicles are well maintained with strong AC cooling and luggage space for passengers. The service supports both airport pickup and airport drop travel. Travelers enjoy stress-free transportation without delays. It provides reliable taxi service for airport commuting."
},
{
name: "NMIA Cab Service Navi Mumbai",
description: "NMIA cab service Navi Mumbai provides dependable airport transportation for passengers traveling to or from Navi Mumbai International Airport. The service includes comfortable sedans, SUVs, and premium MPV vehicles for individual travelers and families. Professional drivers ensure punctual pickups and safe driving throughout the journey. Vehicles provide spacious interiors and strong air conditioning for comfortable travel. The cab service operates across Navi Mumbai and nearby areas. Travelers enjoy convenient booking options and reliable service. It ensures comfortable airport transportation."
},
{
name: "NMIA Airport Pickup Taxi",
description: "NMIA airport pickup taxi offers reliable transportation for passengers arriving at Navi Mumbai International Airport. Professional drivers greet travelers at the airport terminal and assist with luggage. Vehicles provide spacious seating and smooth ride quality for comfortable travel. The pickup service is available for hotels, offices, and residential areas across Navi Mumbai. Passengers enjoy convenient travel immediately after landing. The taxi ensures safe driving and comfortable transportation. It is a reliable solution for airport arrivals."
},
{
name: "NMIA Airport Drop Cab",
description: "NMIA airport drop cab provides convenient transportation for passengers traveling from Navi Mumbai to the airport. The service ensures timely pickup so travelers can reach the airport before their flight departure. Vehicles provide comfortable seating and air-conditioned interiors for relaxed travel. Professional drivers plan efficient routes to avoid delays. The cab service is ideal for business travelers and families. Passengers enjoy reliable transportation without travel stress. It ensures safe and punctual airport drop services."
},
{
name: "Cab Booking NMIA Airport",
description: "Cab booking NMIA airport allows passengers to easily reserve vehicles for airport transportation. Travelers can book sedans, SUVs, or MPV vehicles depending on group size and travel needs. Online and phone booking options provide quick confirmation for airport trips. Professional drivers ensure punctual pickup services and safe driving. The booking service supports both airport pickup and drop journeys. Vehicles provide comfortable seating and luggage space. Travelers benefit from convenient and reliable airport cab reservations."
},
{
name: "Taxi Booking NMIA Airport Online",
description: "Taxi booking NMIA airport online provides quick digital reservations for passengers planning airport transportation. Travelers can easily book taxis online with instant confirmation. Vehicles provide comfortable seating and smooth ride quality for airport journeys. Professional drivers ensure safe driving and punctual pickups across Navi Mumbai locations. The service is ideal for business travelers and tourists. Online booking simplifies travel planning and saves time. Passengers enjoy hassle-free airport transportation."
},
{
name: "Cheap NMIA Airport Cab",
description: "Cheap NMIA airport cab service provides affordable airport transportation without compromising safety or comfort. Travelers can choose economical sedans and SUVs for budget-friendly travel. Vehicles provide comfortable seating and reliable ride performance. Professional drivers ensure punctual pickup services and safe driving. The service is suitable for daily commuters and budget travelers. Passengers enjoy economical fares and convenient travel options. It ensures reliable airport transportation at affordable rates."
},
{
name: "Best NMIA Airport Taxi Service",
description: "Best NMIA airport taxi service provides premium airport transportation with reliable vehicles and professional drivers. Travelers receive punctual pickup services and smooth ride experiences. Vehicles offer spacious seating and air-conditioned interiors for comfortable travel. The service is ideal for business travelers, families, and tourists. Professional drivers ensure safe driving and courteous service. Passengers enjoy dependable airport transportation. It ensures a high-quality travel experience."
},
{
name: "24 Hour NMIA Airport Taxi",
description: "24 hour NMIA airport taxi service provides round-the-clock transportation for passengers traveling at any time of the day. The service supports early morning and late-night airport transfers. Vehicles provide comfortable seating and reliable ride quality for passengers. Professional drivers ensure punctual pickups across Navi Mumbai locations. Travelers can book taxis anytime for airport travel. The service ensures dependable transportation availability. Passengers enjoy flexible travel options for airport journeys."
},
{
name: "Innova NMIA Airport Cab",
description: "Innova NMIA airport cab provides spacious MPV transportation ideal for families and group travelers. The Toyota Innova offers comfortable seating and smooth highway performance for airport journeys. Professional drivers ensure punctual pickup services and safe driving. Vehicles provide ample luggage space for travelers with bags. The service is ideal for airport group transfers and corporate travel. Passengers enjoy premium comfort and reliable service. It provides convenient airport transportation."
},
{
name: "Sedan NMIA Airport Taxi",
description: "Sedan NMIA airport taxi provides economical and comfortable sedan transportation for airport transfers. Vehicles like Swift Dzire and similar sedans offer smooth ride quality and efficient travel performance. Professional drivers ensure punctual pickup services and safe driving. The sedan taxi is ideal for individual travelers and small families. Passengers enjoy air-conditioned comfort and luggage space. The service ensures affordable airport transportation. Travelers experience stress-free journeys."
}
],

tableData: [
["NMIA Airport Cabs","Navi Mumbai International Airport Taxi"],
["NMIA Cab Service Navi Mumbai","NMIA Airport Pickup Taxi"],
["NMIA Airport Drop Cab","Cab Booking NMIA Airport"],
["Taxi Booking NMIA Airport Online","Cheap NMIA Airport Cab"],
["Best NMIA Airport Taxi Service","24 Hour NMIA Airport Taxi"],
["Innova NMIA Airport Cab","Sedan NMIA Airport Taxi"]
],


whychoose: [
  {
    WhyChooseheading: "Experienced Airport Drivers",
    WhyChoosedescription: "Our drivers are highly experienced with Navi Mumbai International Airport (NMIA) routes and nearby highways. They ensure timely pickups and smooth airport transfers without delays."
  },
  {
    WhyChooseheading: "Transparent Airport Cab Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for NMIA cab services. Customers receive clear details about travel fares, toll charges, and airport pickup costs before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Navi Mumbai International Airport cab service operates 24 hours a day. Whether your flight arrives early morning or late at night, our cabs are always available for reliable airport transportation."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable airport travel experience."
  },
  {
    WhyChooseheading: "Flexible Airport Pickup & Drop",
    WhyChoosedescription: "We offer flexible travel options including airport pickup, airport drop, one-way cab bookings, and round-trip airport transfers from Navi Mumbai International Airport."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Navi Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, railway stations, and residential areas across Navi Mumbai for smooth airport transfers."
  },
  {
    WhyChooseheading: "Reliable Airport Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Navi Mumbai International Airport cab bookings thanks to our punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide cab service for Navi Mumbai International Airport (NMIA)?", answer: "Yes, Omshree Cabs provides reliable airport pickup and drop services for Navi Mumbai International Airport." },
  { question: "Is NMIA cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7 to match flight schedules." },
  { question: "Which vehicles are available for NMIA airport transfers?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way airport drop?", answer: "Yes, we offer one-way airport pickup and drop services." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and business centers across Navi Mumbai." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can I book airport cab service online?", answer: "Yes, customers can easily book NMIA cab services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during peak travel hours and holiday seasons." },
  { question: "Do you provide corporate airport transfers?", answer: "Yes, we provide airport transfer services for corporate travelers and business executives." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Mehta",
    feedback:
      "Booked Omshree Cabs for Navi Mumbai International Airport pickup. The driver arrived on time and the journey was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Patil",
    feedback:
      "Excellent NMIA airport cab service. Clean vehicle, polite driver, and smooth travel experience.",
    rating: 5
  }
];







































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Omshree Cab",
  "description": "Omshree Cab provides reliable cab services at Navi Mumbai International Airport (NMIA). We offer airport pickups, drop-offs, Innova and sedan cabs, 24-hour taxi service, and online booking options.",
  "telephone": "+91 9892544084",
  "url": "https://www.omshreecab.com",
  "areaServed": {
    "@type": "City",
    "name": "Navi Mumbai, Maharashtra, India"
  },
  "serviceType": [
    "NMIA Airport Cabs",
    "Navi Mumbai International Airport Taxi",
    "NMIA Cab Service Navi Mumbai",
    "NMIA Airport Pickup Taxi",
    "NMIA Airport Drop Cab",
    "Cab Booking NMIA Airport",
    "Taxi Booking NMIA Airport Online",
    "Cheap NMIA Airport Cab",
    "Best NMIA Airport Taxi Service",
    "24 Hour NMIA Airport Taxi",
    "Innova NMIA Airport Cab",
    "Sedan NMIA Airport Taxi"
  ]
};







  return (
    <div>
      
<Helmet>
  <title>Navi Mumbai International Airport (NMIA) Cabs | Omshree Cab</title>
  <meta
    name="description"
    content="Omshree Cab offers reliable Navi Mumbai International Airport (NMIA) cabs with 24-hour service, airport pickups & drops, Innova and sedan options, and online booking."
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/105.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiinternationairport;